export const contactsData =
[
    {
        'id': 'directorate-supply',
        'title': 'Дирекция по снабжению',
        'contacts': [
            {
                'name': 'Гребенникова Мария Владимировна',
                'speciality': 'И.О. Директор по снабжению ',
                'phones': [
                    {
                        'text': '+7 (3843) 99-76-23',
                        'value': '+73843997623'
                    },
                    {
                        'text': '+7 (923) 622-22-87',
                        'value': '+79236222287'
                    }
                ],
                'email': 'Mariya.Grebennikova@raspadskaya.ru',
                'description': '',
                'descriptionTitle': ''
            }
        ]
    },
    {
        'id': 'mining-equipment-department',
        'title': 'Управление поставки горно шахтного оборудования (УПГШО)',
        'contacts': [
            {
                'name': 'Кемпель Максим Валерьевич',
                'speciality': 'Начальник управления',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-61',
                        'value': '+73843995661'
                    },
                    {
                        'text': '+7 (905) 907-35-97',
                        'value': '+79059073597'
                    }
                ],
                'email': 'Maxim.Kempel@raspadskaya.ru',
                'description': 'Насосы ЦНС; Вентиляторы местного и главного проветривания шахтные; Конвейера скребковые и зап.части к ним; Буровые станки и зап.части к ним; Сверла пневматические; Анкерустановщики; Цепи и комплектующие для ГШО; Высоконапорные маслостанции; Котельное оборудование; Модульные здания.',
                'descriptionTitle': ''
            },
            {
                'name': 'Машукова Елена Валерьевна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-59',
                        'value': '+73843995659'
                    },
                    {
                        'text': '+7 (905) 914-88-82',
                        'value': '+79059148882'
                    }
                ],
                'email': 'Elena.Mashukova@raspadskaya.ru',
                'description': 'Очистное борудование (комбайны, конвейеры, перегружатели) и зап.части к ним; Кабелеукладчики; Проходческие комбайны и запчасти к ним; скребки к очистному оборудованию; мех крепь и зап.части к мех.крепи; Подъемные машины и зап.части к ним.',
                'descriptionTitle': ''
            },
            {
                'name': 'Патрушева Дарья Михайловна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-64',
                        'value': '+73843995664'
                    },
                    {
                        'text': '+7 (961) 711-7291',
                        'value': '+79617117291'
                    }
                ],
                'email': 'Daria.Patrusheva@raspadskaya.ru',
                'description': 'Грузоподъемное оборудование и зап.части к нему; Лебедки; Компрессоры и запчасти к ним; Гидростойки, Домкраты, Подшипники; Канатно-кресельная дорога; Запчасти к МДК; Оборудование водоочистки и воздухоочистки (ультрафиолетовые установки, хлораторы, модули очистки,запчасти); Дизелевозное оборудование и запасные части к нему; Чистители конвейерных лент.',
                'descriptionTitle': ''
            },
            {
                'name': 'Ширяева Галина Николаевна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-53',
                        'value': '+73843995653'
                    },
                    {
                        'text': '+7 (905) 907-11-58',
                        'value': '+79059071158'
                    }
                ],
                'email': 'Galina.Shiryaeva3@raspadskaya.ru',
                'description': 'Ролики конвейерные; Пресс-фильтры обогатительные и расходные материалы к ним; Флотомашины и расходные материалы к ним Автоматизированые установки приготовления флокулянта; Воздухо-нагревательные установки; Тормоза ТКГ и зап. части к ним; Ленточные конвейера и зап.части к ним; Редукторы; Барабаны; Турбомуфты; гидромуфты; муфты, полумуфты; Установки противопожарного оборудования (УАП, АУПТ, РУЗРК, ШРД) и запчасти к ним; Пункт переключения в самоспасатели ППС; Пункт коллективного спасения ПКС, Туманообразующие системы.',
                'descriptionTitle': ''
            },
            {
                'name': 'Русанова Ирина Александровна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-63',
                        'value': '+73843995663'
                    }
                ],
                'email': 'Irina.Rusanova2@raspadskaya.ru',
                'description': 'Обогатительное оборудование и запчасти к нему (дробилки,элеваторы, сепараторы, центрифуги и т.д.); Расходные материалы на обогатительное оборудование; Подъемное оборудование (парашюты, прицепные устройства, шкивы, клети, скипы).',
                'descriptionTitle': ''
            },
            {
                'name': 'Красичкова Алеся Евгеньевна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-59-91',
                        'value': '+73843995991'
                    },
                    {
                        'text': '+7 (961) 726-06-69',
                        'value': '+79617260669'
                    }
                ],
                'email': 'Alesya.Krasichkova@raspadskaya.ru',
                'description': 'Импортные насосы и запасные к ним; Станки общепромышленные; Теплообменники, подогреватели и запчасти к ним; Котельное оборудование; Насосные станции очистного комплекса; Углесосы и зап.части к ним; Дизелевозное оборудование; Гидронасосы.',
                'descriptionTitle': ''
            },
            {
                'name': 'Артемьева Татьяна Олеговна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-79-43',
                        'value': '+73843997943'
                    },
                    {
                        'text': '+7 (905) 066-0839',
                        'value': '+79050660839'
                    }
                ],
                'email': 'Tatyana.Artemieva@raspadskaya.ru',
                'description': 'Конвейера скребковые и зап.части к ним; Подземная самоходная техника и запасные части к ним; Сверла пневматические; Анкерустановщики; Подшипники; Цепи и комплектующие для ГШО (цепи грузовые, тяговые и общего назаначения, звенья); Стрелочные переводы; Буровые станки; Высоконапорные маслостанции; Вентиляционное оборудование и зап.части к нему.',
                'descriptionTitle': ''
            }
        ]
    },
    {
        'id': 'logistics-department',
        'title': 'Управление материально технического обеспечения (УМТС)',
        'contacts': [
            {
                'name': 'Хворова Любовь Федоровна',
                'speciality': 'Начальник управления',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-39',
                        'value': '+73843995639'
                    },
                    {
                        'text': '+7 (961) 712-98-92',
                        'value': '+79617129892'
                    }
                ],
                'email': 'Lyubov.Khvorova@raspadskaya.ru',
                'description': 'Ленты конвейерные.',
                'descriptionTitle': ''
            },
            {
                'name': 'Дичковская Татьяна Александровна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-69',
                        'value': '+73843995669'
                    },
                    {
                        'text': '+7 (961) 712-98-91',
                        'value': '+79617129891'
                    }
                ],
                'email': 'Tatyana.Dichkovskaya@raspadskaya.ru',
                'description': 'Вентрубы и комплектующие (аккумуляторы, тройники, хомуты); Трубы; ГСМ (ДТ+газойль+бензин ,масла); Футеровка; Фланцы, БРС; Материалы для проходки (анкера, металлокрепь).',
                'descriptionTitle': ''
            },
            {
                'name': 'Граборова Надежда Валерьевна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-72',
                        'value': '+73843995672'
                    },
                    {
                        'text': '+7 (960) 935-56-51',
                        'value': '+79609355651'
                    }
                ],
                'email': 'Nadezhda.Graborova@raspadskaya.ru',
                'description': 'Смолы и комплектующие; Ампулы; Рукава высокого давления (РВД); Гидравлика (муфты, тройники, скобы); Клей, герметики, фиксаторы, очистители Loctite, Трибопласт и др.; Рукава напорные, напорно-всасывающие, ремни Стропы, хомуты, скобы; Кольца, манжеты, рти (рукава и ремни) (по ГОСТу); кабельные вводы, вкладыши; Шпала и брус (жд по ГОСТ); Инструмент; Система LOTO; Сетка, лавное перекрытие; МВСП (прокладки, втулки), башмаки горочные.',
                'descriptionTitle': ''
            },
            {
                'name': 'Кривоусова Марина Валерьевна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-70',
                        'value': '+73843995670'
                    },
                    {
                        'text': '+7 (913) 325-98-78',
                        'value': '+79133259878'
                    }
                ],
                'email': 'Marina.Krivousova@raspadskaya.ru',
                'description': 'Технические газы (кислород, углекислота, азот, аргон, смесь К18, кислород жидкий, пропан) Цементные смеси; Пенообразователь; Инертная пыль; Материалы для хим.упрочнения (клей, пена); Самоспасатели , патроны, тренажеры, прибор ПГС; П/пожарное материалы; Смачиватель, антипирогенный состав; МВСП (переводы, рельсы рамные, крестовины, рельсы с остряками, рельсы с крестовинами); Мешки водяного заслона; геотубы; Полотно армированное; Двухкомпонентная система напыления.',
                'descriptionTitle': ''
            },
            {
                'name': 'Колышева Алена Владимировна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-71',
                        'value': '+73843995671'
                    },
                    {
                        'text': '+7 (905) 964-31-37',
                        'value': '+79059643137'
                    }
                ],
                'email': 'Alena.Kolysheva@raspadskaya.ru',
                'description': 'Флокулянты, регенты, флотэки; Уголь для котельных; Огнеупоры; Щебень шлаковый, горных пород, песок, цемент; ЖРК; ЖБК; Электроизоляция; Строительные материалы; Химическая продукция; Лесная продукция.',
                'descriptionTitle': ''
            },
            {
                'name': 'Каликаева Екатерина Александровна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-49',
                        'value': '+73843995649'
                    },
                    {
                        'text': '+7 (903) 943-27-77',
                        'value': '+79039432777'
                    }
                ],
                'email': 'Ekaterina.Kalikaeva@raspadskaya.ru',
                'description': 'Запорная арматура; Металлопрокат, МВСП (подкладки, накладки); Сетка металлическая; Рельсы; Канаты; Электроды; Фурнитура стеклопластиковая (отводы, тройники и т.д.); Фитинги стеклопластик.',
                'descriptionTitle': ''
            },
            {
                'name': 'Усенко Виктория Евгеньевна',
                'speciality': 'Специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-72-23',
                        'value': '+73843997223'
                    }
                ],
                'email': 'Viktoriya.Usenko@raspadskaya.ru',
                'description': 'Металлопрокат (ЕвразМаркет); Футеровка; Пантоны.',
                'descriptionTitle': ''
            }
        ]
    },
    {
        'id': 'quarry-equipment-department',
        'title': 'Управление поставки карьерной спецтехники (УПКСТ)',
        'contacts': [
            {
                'name': 'Печеркин Тимофей Дмитриевич',
                'speciality': 'Начальник управления',
                'phones': [
                    {
                        'text': '+7 (3843) 99-76-91',
                        'value': '+73843997691'
                    },
                    {
                        'text': '+7 (905) 907-36-92',
                        'value': '+79059073692'
                    }
                ],
                'email': 'Timofey.Pecherkin@raspadskaya.ru',
                'description': 'Легковые, грузовые автомобили; Ковши, отвалы; Грузовые автомобили (на шасси Камаз, УРАЛ), краны; Электродвигатели и генераторы для самосвалов БЕЛАЗ; Тепловозы.',
                'descriptionTitle': ''
            },
            {
                'name': 'Гладышев Павел Евгеньевич',
                'speciality': 'Категорийный менеджер по закупке карьерной спецтехники',
                'phones': [
                    {
                        'text': '+7 (3843) 99-58-81',
                        'value': '+73843995881'
                    },
                    {
                        'text': '+7 (960) 930-92-31',
                        'value': '+79609309231'
                    }
                ],
                'email': 'Pavel.Gladyshev@raspadskaya.ru',
                'description': 'Карьерная спецтехника (самосвалы, бульдозеры, экскаваторы, погрузчики, грейдеры, буровые станки ОГР и ГРР и т.д.); Разработка и реализация стратегии закупки карьерной спецтехники, в т.ч. анализ и ведение прайс-листов с долгосрочным ценообразованием; Складская спецтехника и погрузчики (вилочные).',
                'descriptionTitle': ''
            },
            {
                'name': 'Стрекалов Станислав Валерьевич',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-36',
                        'value': '+73843995636'
                    },
                    {
                        'text': '+7 (905) 907-33-97',
                        'value': '+79059073397'
                    }
                ],
                'email': 'Stanislav.Strekalov@raspadskaya.ru',
                'description': 'З/ч к карьерной технике (импортные+ ЭКГ) + ДВС (в т.ч. КАМАЗ) + ЮЖГРУ; Защита ковшей экскаваторов (коронки, пальцы произв. MTG, Hensley, ESCO и др.); Автошины легковые, грузовые, КГШ, СКГШ; Фильтры для карьерной спецтехники и авто, мембраны газораспределительные; Ж/д запчасти КПТ и ТПТУ; Запасные части для самосвалов БЕЛАЗ, в т.ч.: - для систем смазки (GRACO, TRIBO, LINKOLN и др.) - смежные позиции иных производителей - электрощетки.',
                'descriptionTitle': ''
            },
            {
                'name': 'Горлышков Виталий Викторович',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-70-12',
                        'value': '+73843997012'
                    }
                ],
                'email': 'Vitaly.Gorlyshkov@raspadskaya.ru',
                'description': 'ГРИ (штанги, резци, коронки, долото, забурники, бур., снаряды); Инструмент к бурстанкам для ОГР и ГРР; Дизельные насосные установки, мотопомпы.',
                'descriptionTitle': ''
            },
            {
                'name': 'Кралевецкая Анастасия Игоревна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-76-13',
                        'value': '+73843997613'
                    },
                    {
                        'text': '+7 (906) 925-18-23',
                        'value': '+79069251823'
                    }
                ],
                'email': 'Anastasia.Kralevetskaya@raspadskaya.ru',
                'description': 'Легковые автомобили; Складская спецтехника и погрузчики (вилочные); Электродвигатели и генераторы для самосвалов БЕЛАЗ;  З/ч к системам смазки БЕЛАЗ; Запчасти на погрузчики, складскую технику, болотоходы; Ходовые системы гусеничные; Фильтры для карьерной спецтехники и авто.',
                'descriptionTitle': ''
            },
            {
                'name': 'Брусенцева Наталья Александровна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-78-93',
                        'value': '+73843997893'
                    },
                    {
                        'text': '+7 (960) 920-62-74 ',
                        'value': '+79609206274'
                    }
                ],
                'email': 'Natalia.Brusentseva@raspadskaya.ru',
                'description': 'Ходовые системы гусеничные; Болотоходы и зч к ним; Запасные части к спецтехнике для ЮЖГРУ;  З/ч к самосвалам БЕЛАЗ смежные; Запчасти КАМАЗ, ГАЗ, УАЗ, ВОЛЬВО, РЕНО, СИТРАК для АТП; Ж/д запчасти КПТ и ТПТУ; Заправочное оборудование (топливозаправка, системы налива и др.).',
                'descriptionTitle': ''
            }
        ]
    },
    {
        'id': 'electric-supply-department',
        'title': 'Управление поставки электроэнергетического оборудования (УПЭО)',
        'contacts': [
            {
                'name': 'Гук Александр Сергеевич',
                'speciality': 'Начальник управления',
                'phones': [
                    {
                        'text': '+7 (3843) 99-59-81',
                        'value': '+73843995981'
                    },
                    {
                        'text': '+7 (913) 333-9399',
                        'value': '+79133339399'
                    }
                ],
                'email': 'Aleksandr.Guk@raspadskaya.ru',
                'description': 'Станции компактные КСМ, КСМП;  Подстанции взрывозащищенные КТПВМ; Весы (оборудование, сооружения).',
                'descriptionTitle': ''
            },
            {
                'name': 'Демьянова Елена Ивановна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-77-27',
                        'value': '+73843997727'
                    },
                    {
                        'text': '+7 (905) 908-07-11',
                        'value': '+79059080711'
                    }
                ],
                'email': 'Elena.Demianova@raspadskaya.ru',
                'description': 'Электро вибраторы; Датчики и КИП; Манометры; Системы АГК и газоанализаторы; Система поиска и слежения FLEXCOM; Системы контроля и управления Davis Derby; Системы Ингортех; Шахтная автоматика (коробки разветвит., муфты тройниковые, ящики соединительные, датчики, выключатели…); Светильники головные; Зарядные станции и запчасти к ним; Светильники и прожектора для помещений и наружней установки; Лампы; Светодиодная лента.',
                'descriptionTitle': ''
            },
            {
                'name': 'Степанова Наталья Валентиновна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-65',
                        'value': '+73843995665'
                    }
                ],
                'email': 'Natalia.Stepanova@raspadskaya.ru',
                'description': 'Кабельно-проводниковая продукция; Генераторы электрические; Электродвигатели; Аккумуляторные батареи (тяговые, бытовые, автомобильные); Бытовая техника; Медицинские и лабораторноые приборы; Алкотестеры для медпунктов и мобильные; Оборудование столовой.',
                'descriptionTitle': ''
            },
            {
                'name': 'Щеглова Анастасия Евгеньевна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-74-52',
                        'value': '+73843997452'
                    },
                    {
                        'text': '+7 (905) 907-93-31',
                        'value': '+79059079331'
                    }
                ],
                'email': 'Anastasia.Scheglova@raspadskaya.ru',
                'description': 'Частотные преобразователи общепромышленные; Низковольтная аппаратура; Электроустановочные изделия; Аппаратура ВЭЛАН; Гидроэлектротолкатели, толкатели, привода; Мачты освещения мобильные; Приборы ИЗСТ; ПКП; ПКА; Расходомеры; Водосчетчики;Продукция Взлет-Кузбасс; Блоки к взрывозащищенной аппаратуре (к пускателям); З/ч к КРУВ; Ячейки КРУВ;Пускатели, выключатели взрывозащищеные.',
                'descriptionTitle': ''
            },
            {
                'name': 'Кононцова Анна Викторовна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-71-19',
                        'value': '+73843997119'
                    }
                ],
                'email': 'Anna.Konontsova@raspadskaya.ru',
                'description': 'Радиостанции и рации общепромышленные; Телефония (ТАШ, Таштагол, громкоговорители шахтовые и з/ч к ним); Обогреватели; Тепловые пушки; ТЭНы; Сушильные шкафы; Узлы нагрева и оборудование котельных; Сварочное оборудование, запчасти к нему; Шлагбаумы; Станки шиномонтажные, маслозаправочные, подъемники, оборудование СТО; Подстанции; Распредустройства РУ-6кВ; Геодезическое оборудование, тахеометры; Видеорегистраторы, видеокамеры.',
                'descriptionTitle': ''
            }
        ]
    },
    {
        'id': 'works-services-department',
        'title': 'Управление закупки работ и услуг (УЗРУ)',
        'contacts': [
            {
                'name': 'Федорова Дарья Сергеевна',
                'speciality': 'И.О. Начальник управления',
                'phones': [
                    {
                        'text': '+7 (3843) 99-78-05',
                        'value': '+73843997805'
                    },
                    {
                        'text': '+7 (905) 907-12-83',
                        'value': '+79059071283'
                    }
                ],
                'email': 'Daria.Fedorova@raspadskaya.ru',
                'description': 'Проведение конкурсных процедур на закупку работ/услуг; Строительно-монтажные работы; Демонтажные работы; Ремонты ГШО; Услуги клининга.',
                'descriptionTitle': ''
            },
            {
                'name': 'Петрова Татьяна Леонидовна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-56-55',
                        'value': '+73843995655'
                    },
                    {
                        'text': '+7 (906) 984-02-19',
                        'value': '+79069840219'
                    }
                ],
                'email': 'Tatyana.Petrova2@raspadskaya.ru',
                'description': 'Реализация нелеквидных ТМЦ.',
                'descriptionTitle': ''
            },
            {
                'name': 'Федорова Дарья Сергеевна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-78-05',
                        'value': '+73843997805'
                    },
                    {
                        'text': '+7 (905) 907-12-83',
                        'value': '+79059071283'
                    }
                ],
                'email': 'Daria.Fedorova@raspadskaya.ru',
                'description': 'Проектные и научно-исследовательские работы; Тарифы на услуги безальтернативных контрагентов; Экспертиза промышленной безопасности; Консалтинг и экспертиза документации; Аренда и ТО; Услуги ИТ и передачи данных.',
                'descriptionTitle': ''
            },
            {
                'name': 'Быковский Денис Валерьевич',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-74-13',
                        'value': '+73843997413'
                    },
                    {
                        'text': '+7 (905) 907-08-53',
                        'value': '+79059070853'
                    }
                ],
                'email': 'Denis.Bykovskiy@raspadskaya.ru',
                'description': 'Ремонт карьерной техники; Ремонт КГШ и РВД; Ремонт секций крепи и гидравлики; Обеспечение питьевой водой; Услуги перевозки угля; Поставка ВВ и средств инициирования.',
                'descriptionTitle': ''
            },
            {
                'name': 'Постоенко Ольга Ивановна',
                'speciality': 'Главный специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-77-63',
                        'value': '+73843997763'
                    },
                    {
                        'text': '+7 (905) 072-37-68',
                        'value': '+79050723768'
                    }
                ],
                'email': 'Olga.Postoenko@raspadskaya.ru',
                'description': 'Ремонт редукторов; Ремонт барабанов конвейеров; Аренда спецтехники; Пассажирские перевозки; Ремонт электрооборудования; Вырубка леса, рекультивация, лесовосстановление; Реализация непрофильных ОС.',
                'descriptionTitle': ''
            },
            {
                'name': 'Галицкая Евгения Владимировна',
                'speciality': 'Ведущий специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-75-96',
                        'value': '+73843997596'
                    }
                ],
                'email': 'Evgenia.Galitskaya@raspadskaya.ru',
                'description': 'Услуги проходки, перекрепки, бурения; Услуги промышленной автоматизации; Услуги утилизации опасных отходов.',
                'descriptionTitle': ''
            },
            {
                'name': 'Масалова Ирина Сергеевна',
                'speciality': 'Специалист',
                'phones': [
                    {
                        'text': '+7 (3843) 99-77-49',
                        'value': '+73843997749'
                    }
                ],
                'email': 'Irina.Masalova@raspadskaya.ru',
                'description': 'Проведение конкурсных процедур на закупку работ/услуг.',
                'descriptionTitle': ''
            }
        ]
    }
]
